import { Routes } from '../const';
import { config } from '../const/mfe-config';
import { LANG } from '../sandbox/const/sandbox-consts';
var defaultState = {
    accountId: '',
    accountIdType: 'guid',
    autopayStatus: null,
    config: config,
    currentLanguage: LANG.EN,
    currentRoute: Routes.PAYMENT_OPTIONS,
    triggerAnalyticsEvent: function () { }
};
export default defaultState;
//# sourceMappingURL=defaultState.js.map